export class Material{
    public MaterialId : number = 0;
    public Name: string;
    public Notes: string = '';
    public Quantity: number = 0;
    public IsActive: boolean = true;
    public RequestId:number;
  }


  export class OutwardMaterial{
    public MaterialId : number = 0;
    public name: string;
    public notes: string = '';
    public quantity: number = 0;
    public IsActive: boolean = true;
    public RequestId:number;
  }

  